import { render, staticRenderFns } from "./OrderIn.vue?vue&type=template&id=6d2a1409&"
import script from "./OrderIn.vue?vue&type=script&lang=js&"
export * from "./OrderIn.vue?vue&type=script&lang=js&"
import style0 from "./OrderIn.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports